import { useFiltersSearch, useQuickSearch, useSearchApi, useStudiesSearch, useVocabSearch } from '../search';
import { IConfig, IModalApi, IToastApi } from '@vivli/shared/infrastructure/interface';
import { IActiveUser, IAssignedAppType, IPlatformSearchHooks } from '@vivli/core/infrastructure/interface';
import { useAppConfigContext, useAssignedAppTypeContext, useModalApiContext, useToastApiContext } from '@vivli/core/infrastructure/context';

interface ISearchInitHook {
    activeUser: IActiveUser;
}

export const useSearchInit = ({ activeUser }: ISearchInitHook): IPlatformSearchHooks => {
    const config = useAppConfigContext();
    const modalApi = useModalApiContext();
    const assignedAppType = useAssignedAppTypeContext();
    const toastApi = useToastApiContext();

    const vocabSearchApi = useVocabSearch(config);
    const studiesSearchApi = useStudiesSearch(config);
    const filtersSearchApi = useFiltersSearch(config);
    const quickSearchApi = useQuickSearch({
        modalApi,
        assignedAppType: assignedAppType.type,
        studiesSearch: studiesSearchApi
    });
    const searchApi = useSearchApi({
        appConfig: config,
        assignedAppType,
        toastApi,
        activeUser,
        vocabSearch: vocabSearchApi,
        studiesSearch: studiesSearchApi,
        filtersSearch: filtersSearchApi
    });

    return {
        vocabSearchApi,
        studiesSearchApi,
        filtersSearchApi,
        quickSearchApi,
        searchApi
    };
};
